import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SmoothLoginBaseComponent } from '@luggagehero/features/user';

@Component({
  selector: 'lh-smooth-login',
  templateUrl: './smooth-login.component.html',
  styleUrls: ['./smooth-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SmoothLoginComponent extends SmoothLoginBaseComponent {
  public get isAppleSignInAvailable(): boolean {
    // Not supporting Apple Sign-in on web for now
    return false;
  }

  public signInWithApple(): Promise<void> {
    throw new Error('Apple sign-in is not supported on web');
  }
}
